import { cn, Tooltip, TooltipContent, TooltipTrigger } from '@design-system';

interface LockedFieldProps {
  active: boolean;
  children: React.ReactNode;
  side?: 'top' | 'right' | 'bottom' | 'left';
  className?: string;
  tooltipText?: string;
}

const TOOLTIP_TEXT = 'This field is preset and cannot be edited.';

export function LockedField({ active, children, side, className, tooltipText }: LockedFieldProps) {
  if (!active) {
    return <>{children}</>;
  }

  return (
    <Tooltip disableHoverableContent>
      <TooltipTrigger asChild>
        <div className={cn('cursor-not-allowed', className)}>
          <div
            className="pointer-events-none opacity-50"
            aria-disabled="true"
            onKeyDown={e => e.preventDefault()}
            onFocusCapture={e => e.stopPropagation()}
            tabIndex={-1}
          >
            {children}
          </div>
        </div>
      </TooltipTrigger>
      <TooltipContent
        side={side}
        className="max-w-64"
      >
        {tooltipText ?? TOOLTIP_TEXT}
      </TooltipContent>
    </Tooltip>
  );
}
